import { IAnnotation } from '@se/models';

export enum ChannelType {
    LEAD_I = 0,
    LEAD_II = 1,
    LEAD_III = 2,
    LEAD_AVR = 3,
    LEAD_AVL = 4,
    LEAD_AVF = 5,
    LEAD_V1 = 6,
    LEAD_V2 = 7,
    LEAD_V3 = 8,
    LEAD_V4 = 9,
    LEAD_V5 = 10,
    LEAD_V6 = 11,
    LEAD_V3R = 12,
    LEAD_V4R = 13,
    LEAD_V5R = 14,
    LEAD_V7 = 15,
    LEAD_V8 = 16,
    LEAD_V9 = 17,
    UNKNOWN = 100,
}

export interface ISample {
    value: number;
}

export interface ISourceChannel {
    samplingFrequency: number;
    samplingCount: number;
    samples: Array<number>;
    annotations: Array<IAnnotation>;

    name: string;
    type: ChannelType;
    order: number;
}

export interface IChannel {
    samplingFrequency: number;
    samplingCount: number;
    samples: Array<ISample>;
    annotations: Array<IAnnotation>;

    name: string;
    type: ChannelType;
    order: number;
}

export interface ITrace {
    channel: IChannel;
    index: number;
}
